// extracted by mini-css-extract-plugin
export var cardContainer = "_oz-0";
export var cardHeader = "_oz-2";
export var collapsedState = "_oz-3";
export var dragHandle = "_oz-5";
export var dragHandleIcon = "_oz-6";
export var dragging = "_oz-1";
export var titleArea = "_oz-4";